export default {
    find(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/find', params, response);
    },
    insertOrg(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/insertOrg', params, response);
    },
    updateOrg(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/updateOrg', params, response);
    },
    deleteOrg(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/deleteOrg', params, response);
    },
    findTree(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/findTree', params, response);
    },
    findOrgTypes(params, response) {
        window.vue.$apiAxios.get('/OrgManagerController/findOrgTypes', params, response);
    },
    listPropertyInfo(params, response) {
        window.vue.$apiAxios.post('/OrgManagerController/listPropertyInfo', params, response);
    },
    listAllIcon(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/listAllIcon', params, response);
    },
    orgSort(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/orgSort', params, response);
    },
    // 检测是否重复
    checkPropertyRepeat(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/checkPropertyRepeat', params, response);
    },
    // 检测编号是否重复
    checkCodeRepeat(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/checkCodeRepeat', params, response);
    },
    // 导入
    uploadOrgZip(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/uploadOrgZip', params, response);
    },
    // 导出
    exportOrg(params, responseType, response) {
        window.vue.$apiAxios.downloadPost('/OrgManagerController/exportOrgCsv', params, responseType, response);
    },
    //查询是否配置国标
    getDictValuesByType(params, response) {
        window.vue.$apiAxios.postRequestBody('/setting/dictController/getDictValuesByType', params, response);
    }
};
